export const isLongName = (name: string) => name.length > 9;
